/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type AdjustGooseGamePlayerPointsMutationVariables = Types.Exact<{
  event_attendee_id: Types.Scalars["Float"];
  points_change: Types.Scalars["Float"];
  note: Types.Scalars["String"];
}>;

export type AdjustGooseGamePlayerPointsMutation = {
  adjustGooseGamePlayerPoints: Pick<
    Types.GooseGamePlayer,
    "id" | "current_points" | "total_points"
  >;
};

export const AdjustGooseGamePlayerPointsDocument = gql`
  mutation adjustGooseGamePlayerPoints(
    $event_attendee_id: Float!
    $points_change: Float!
    $note: String!
  ) {
    adjustGooseGamePlayerPoints(
      event_attendee_id: $event_attendee_id
      points_change: $points_change
      note: $note
    ) {
      id
      current_points
      total_points
    }
  }
`;

/**
 * __useAdjustGooseGamePlayerPointsMutation__
 *
 * To run a mutation, you first call `useAdjustGooseGamePlayerPointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdjustGooseGamePlayerPointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adjustGooseGamePlayerPointsMutation, { data, loading, error }] = useAdjustGooseGamePlayerPointsMutation({
 *   variables: {
 *      event_attendee_id: // value for 'event_attendee_id'
 *      points_change: // value for 'points_change'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useAdjustGooseGamePlayerPointsMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    AdjustGooseGamePlayerPointsMutation,
    AdjustGooseGamePlayerPointsMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    AdjustGooseGamePlayerPointsMutation,
    AdjustGooseGamePlayerPointsMutationVariables
  >(AdjustGooseGamePlayerPointsDocument, baseOptions);
}
export type AdjustGooseGamePlayerPointsMutationHookResult = ReturnType<
  typeof useAdjustGooseGamePlayerPointsMutation
>;
export type AdjustGooseGamePlayerPointsMutationResult =
  ApolloReactCommon.MutationResult<AdjustGooseGamePlayerPointsMutation>;
export type AdjustGooseGamePlayerPointsMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    AdjustGooseGamePlayerPointsMutation,
    AdjustGooseGamePlayerPointsMutationVariables
  >;
